import { Button, Col, Row } from "antd";
import Checkbox from "antd/es/checkbox/Checkbox";
import { useEffect, useState } from "react";
import { FaKey } from "react-icons/fa";
import { FiTrash } from "react-icons/fi";
import { REACTION_TYPE_LABEL } from "../../../config/Constant";
import { useChatContext } from "../../../context/ChatContext";
import { formatTime } from "../../../utils/formatTime";
import { CustomAvatar } from "../../avatar/CustomAvatar";
import { useDirectoryContext } from "./DirectoryContext";
import { renderMessage } from "../../chat/renderMessage";

const BasicMemberInfo = ({
  languageMap,
  memberGroup,
  screenInfo,
  onChangeMembersCheckBox,
  isHost,
  isMe,
  isAdmin,
  hasRead,
  lastSeenTs,
  isSelectedCombobox,
  seenTsInMessage,
  isView,
  isCC,
  isModaReaction,
  reactionOfUser,
  hasOrganizations,
}) => {
  const { onDeleteItem } = useDirectoryContext();
  const chatContext = useChatContext();
  const { selectedConversation } = chatContext || {};
  const [isMobile, setIsMobile] = useState(window.innerWidth < 860);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 860);
  };

  const filterReaction = REACTION_TYPE_LABEL?.find((item) =>
    reactionOfUser?.includes(item?.type)
  );

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getClassNameByRole = () => {
    if (isHost) {
      return "bg-[red] w-[40px] h-[40px]";
    } else if (isAdmin) {
      return "bg-[#007fff] w-[40px] h-[40px]";
    } else return "bg-[#87d068] w-[40px] h-[40px]";
  };

  const getIconFromScreenInfo = () => {
    switch (screenInfo) {
      case "CREATE_GROUP": {
        return (
          <Button
            className="bg-[#e00d0d] text-[white]"
            onClick={() => onDeleteItem(memberGroup?.paths?.[0])}
            icon={<FiTrash className="text-[18px]" />}
          ></Button>
        );
      }
      case "VIEW_MEMBER_IN_GROUP": {
        if (isHost) {
          return <FaKey className="bi bi-key text-[18px] align-icon" />;
        } else if (
          selectedConversation?.role === "HOST" &&
          selectedConversation?.type !== "NOTIFICATION"
        ) {
          return (
            <>
              {!isModaReaction && (
                <Checkbox
                  checked={isSelectedCombobox}
                  value={memberGroup?.userId}
                  onChange={(e) => {
                    onChangeMembersCheckBox(e?.target?.value);
                  }}
                />
              )}
            </>
          );
        } else {
          return <div />;
        }
      }
      case "READ_UNREAD": {
        return <div>{hasRead ? formatTime(lastSeenTs) : ""}</div>;
      }

      default: {
        return <div />;
      }
    }
  };

  const generatePath = (pathname, i) => {
    return (
      <div key={`${pathname}_${i}`} className="flex items-center">
        <div className={isMobile ? "text-[10px]" : "text-[14px]"}>
          <span className="text-[#d33b3d] p-[2px]">*</span>
          {pathname}
        </div>
      </div>
    );
  };

  const generateRoleNameChatting = () => {
    if (isHost) {
      return (
        <span className="text-xs">
          {languageMap?.["chat.role.conversation.host"] ?? "Host"}
        </span>
      );
    } else if (isAdmin) {
      return (
        <span className="text-xs">
          {languageMap?.["chat.role.conversation.admin"] ?? "Admin"}
        </span>
      );
    } else
      return (
        <span className="text-xs">
          {languageMap?.["chat.role.conversation.member"] ?? "Member"}
        </span>
      );
  };

  const generateRoleNameNotification = () => {
    if (isHost) {
      return (
        <span>
          {languageMap?.["chat.role.conversation.noti.sender"] ?? "Sender"}
        </span>
      );
    } else if (isCC) {
      return (
        <span>{languageMap?.["chat.role.conversation.noti.cc"] ?? "CC"}</span>
      );
    } else {
      return (
        <span>
          {languageMap?.["chat.role.conversation.noti.recipient"] ??
            "Recipient"}
        </span>
      );
    }
  };

  const getPaths = (paths) => {
    const map = new Map();
    paths.forEach((item) => {
      map.set(item.objectId, { ...item, children: [] });
    });

    paths.forEach((item) => {
      if (item.parentId) {
        map.get(item.parentId)?.children.push(item);
      }
    });

    const result = Array.from(map.values())
      .filter((item) => !item.parentId)
      .map((item) => {
        const allNames = [
          item.name,
          ...item.children.map((child) => child.name),
        ];
        return { name: allNames.join(">") };
      });

    return result;
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Row
      gutter={isMobile ? [4, 0] : [8, 0]}
      className="w-full mb-5 items-center"
    >
      <Col span={isMobile ? 5 : 3} className="flex items-center justify-center">
        <CustomAvatar
          person={memberGroup}
          userId={memberGroup?.userId}
          pos={-1}
          styleCss={{}}
          isShowUserStatus={{ status: true, isAlwaysTrue: false }}
        />
      </Col>
      <Col span={isMobile ? 15 : 18} className="items-center justify-center">
        <Row
          gutter={isMobile ? [4, 0] : [8, 0]}
          className="items-center justify-center text-sm"
        >
          <Col span={isModaReaction ? 17 : isMobile ? 24 : 10}>
            <span
              className={
                isMe
                  ? "font-bold text-[#0091FF] text-[14px]"
                  : "font-bold text-[14px]"
              }
            >
              {isMe
                ? languageMap?.["chat.role.conversation.you"] ?? "You"
                : hasOrganizations
                  ? memberGroup?.username ?? "UNKNOWN MEMBER"
                  : memberGroup?.name ?? "UNKNOWN MEMBER"}
            </span>
            <br />
            {!isView &&
              (selectedConversation?.type !== "NOTIFICATION"
                ? generateRoleNameChatting()
                : generateRoleNameNotification())}
          </Col>

          {!isModaReaction ? (
            <Col span={isMobile ? 24 : 14}>
              {hasOrganizations && memberGroup?.organizations?.length > 0 ? (
                memberGroup?.organizations?.map((item, i) =>
                  getPaths(item?.paths)?.map((path, j) =>
                    generatePath(path?.name, j)
                  )
                )
              ) : memberGroup?.paths?.length > 0 ? (
                getPaths(memberGroup?.paths)?.map((path, i) =>
                  generatePath(path?.name, i)
                )
              ) : (
                <div className="flex items-center">
                  <div className="text-[14px]">
                    <span className="text-[#d33b3d] p-[2px]">*</span>
                    <span>UNKNOWN GROUP</span>
                  </div>
                </div>
              )}
            </Col>
          ) : (
            <Col className="flex justify-end" span={7}>
              <div className="text-[20px]">
                {renderMessage(filterReaction?.label)}
              </div>
            </Col>
          )}
        </Row>
      </Col>
      {/* {seenTsInMessage && (
        <Col span={1} className="text-xs flex justify-end items-center">
          {formatTime(seenTsInMessage)}
        </Col>
      )} */}
      <Col
        span={seenTsInMessage ? 2 : 3}
        className="flex flex-1 items-center justify-end text-[10px]"
      >
        {getIconFromScreenInfo()}
      </Col>
    </Row>
  );
};

export { BasicMemberInfo };
